import { mockPasswordResetRequest, mockVerifyResetCodeRequest, requestPasswordReset } from 'src/app/shared/interfaces/auth/auth-mock';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  PasswordResetRequest,
  PasswordResetResponse,
  RegisterRequest,
  RegisterResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
  SignupCodeRequest,
  SignupCodeResponse,
  VerifyResetCodeRequest,
  VerifyResetCodeResponse,
  VerifySignupCodeRequest,
  VerifySignupCodeResponse,
} from '../../interfaces/auth/auth-interface';

@Injectable({
  providedIn: 'root',
})
export class AuthGateway {
  private urlPrefix: string = '/auth';
  constructor(private httpClient: HttpClient) {}

  public authenticate(email: string, password: string): Observable<any> {
    const url = `${environment.api.url}${this.urlPrefix}/authenticate`;

    // The body containing the user's credentials
    const body = {
      email: email,
      password: password,
    };

    // Sending the POST request to the API endpoint
    return this.httpClient.post(url, body);
  }

  public requestPasswordReset(data: PasswordResetRequest): Observable<PasswordResetResponse> {
    const url: string = `${environment.api.url}${this.urlPrefix}/request-code`;
    return this.httpClient.post<PasswordResetResponse>(url, data);
  }

  public verifyResetCode(data: VerifyResetCodeRequest): Observable<VerifyResetCodeResponse> {
    const url: string = `${environment.api.url}${this.urlPrefix}/verify-code`;
    return this.httpClient.post<PasswordResetResponse>(url, data);
  }

  public resetPassword(data: ResetPasswordRequest): Observable<ResetPasswordResponse> {
    const url: string = `${environment.api.url}${this.urlPrefix}/reset-password`;
    return this.httpClient.post<PasswordResetResponse>(url, data);
  }

  public register(data: RegisterRequest): Observable<RegisterResponse> {
    const url: string = `${environment.api.url}${this.urlPrefix}/register`;
    return this.httpClient.post<RegisterResponse>(url, data);
  }

  public requestSignupCode(data: SignupCodeRequest): Observable<SignupCodeResponse> {
    const url: string = `${environment.api.url}${this.urlPrefix}/signup-request-code`;
    return this.httpClient.post<SignupCodeResponse>(url, data);
  }

  public verifySignupCode(data: VerifySignupCodeRequest): Observable<VerifySignupCodeResponse> {
    const url: string = `${environment.api.url}${this.urlPrefix}/signup-verify-code`;
    return this.httpClient.post<VerifySignupCodeResponse>(url, data);
  }
}
